import * as React from "react";
import { sanitize } from "../commons/utils/sanitize";

export interface PasswordResetSentProps {
  contactUsEmail: string;
  onBackToLogin: () => void;
}

export default class PasswordResetSent extends React.Component<PasswordResetSentProps, {}> {
  render() {
    return (
      <div className="panel">
        <div className="title-bar">
          <h1 className="title">{i18n["Page.PasswordResetSent.Title"]}</h1>
        </div>
        <p
          dangerouslySetInnerHTML={{
            __html: sanitize(String(i18n["Page.PasswordResetSent.Description"])),
          }}
        />
        <p className="v-flex centered" style={{ margin: "2rem 0" }}>
          <button className="button-primary" onClick={() => this.props.onBackToLogin()}>
            {i18n["Page.PasswordResetSent.Submit"]}
          </button>
        </p>

        <p className="h-flex centered">
          <span>{i18n["Page.PasswordResetSent.NeedHelp"]}&nbsp;</span>
          <a className="link" href={"mailto:" + this.props.contactUsEmail}>
            {i18n["Page.PasswordResetSent.ContactUs"]}
          </a>
        </p>
      </div>
    );
  }
}
